import { render, staticRenderFns } from "./_OnlyTrainingItem.vue?vue&type=template&id=72061719&scoped=true&"
import script from "./_OnlyTrainingItem.vue?vue&type=script&lang=js&"
export * from "./_OnlyTrainingItem.vue?vue&type=script&lang=js&"
import style0 from "./_OnlyTrainingItem.vue?vue&type=style&index=0&id=72061719&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72061719",
  null
  
)

export default component.exports